import React from "react";

const LoadingAnimation = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full py-10">
      <div className="relative w-24 h-24 mb-4">
        <div className="absolute inset-0 rounded-full border-4 border-emerald-200 opacity-50 animate-ping"></div>
        <div className="absolute inset-1 rounded-full border-t-4 border-emerald-500 animate-spin"></div>
        <div className="absolute inset-3 flex items-center justify-center rounded-full bg-emerald-100 animate-pulse">
          <div className="w-4/5 h-4/5 rounded-full bg-gradient-to-r from-emerald-300 to-emerald-500 opacity-75"></div>
        </div>
      </div>
      <h3 className="text-lg font-medium text-emerald-700">Carregando dados</h3>
      <p className="text-sm text-gray-500 mt-2 text-center max-w-xs">
        Aguarde enquanto recuperamos as informações
      </p>
    </div>
  );
};

export default LoadingAnimation;
